import { useTaxSelector } from "../redux/general/reduxStore";
import React from "react";
import { useJmfPermissions } from "@mm-products/java-multima-framework";
import { convertEntityPermissionType, EntityPermissions, PermissionNameType } from "@mm-products/java-multima-framework";

export const SUPER_ADMIN_ROLE = "super-admin-role";

export const usePermissions = () => {
    const accountPermissions = useTaxSelector((state) => state.user.permissions);
    const permissions = useJmfPermissions(accountPermissions ?? []);

    const hasAtLeastOnePermissionOrEmpty = React.useCallback(
        (permissionsOrEmpty: Array<PermissionNameType> | undefined) => {
            return (permissionsOrEmpty?.length ?? 0) === 0 || permissions.hasAtLeastOnePermission(permissionsOrEmpty ?? []);
        },
        [permissions]
    );

    const isReadOnly = React.useCallback((permission: EntityPermissions) => {
        const permissions = convertEntityPermissionType(permission);
        return permissions.every((per) => per === "read");
    }, []);

    return { ...permissions, accountPermissions, hasAtLeastOnePermissionOrEmpty, isReadOnly };
};

export default usePermissions;
